import token, { tokenToVars } from '../token';
import Radio from './radio';

export { Radio };
export default tokenToVars(Radio, token);
